import * as React from 'react';
import * as leadDicts from 'dicts/leads';
import {FormattedMessage, FormattedDate} from '@meiko/react-intl';
import Panel from './Panel';
import PanelRow from './PanelRow';
import LeadProgressTd from 'components/views/LeadProgressTd';
import {fullName} from 'utils/people';

const dateTimeFmtOpts = {
	day: 'numeric',
	month: 'numeric',
	year: 'numeric',
};

export default function LeadDetailsPanel({lead}) {
	if (!lead) {
		return null;
	}
	return (
		<Panel title={<FormattedMessage id="Lead information" />}>
			<div className="overflow-x-auto flex flex-col">
				<PanelRow
					label={<FormattedMessage id="State" />}
					value={<FormattedMessage id={leadDicts.marketingLeadStates[lead.state]} />}
				/>
				<PanelRow
					label={<FormattedMessage id="Added" />}
					value={<FormattedDate value={new Date(lead.createdAt)} {...dateTimeFmtOpts} />}
				/>
				<PanelRow
					label={<FormattedMessage id="Lead submitter" />}
					value={lead.user?.data ? fullName(lead.user.data) : '-'}
				/>
				<PanelRow
					label={<FormattedMessage id="Progress" />}
					value={
						<LeadProgressTd
							lead={lead}
							noDate={true}
							navigateTo={() => {}}
							showCallButton={false}
						/>
					}
				/>
				<PanelRow
					label={<FormattedMessage id="Visit" />}
					value={
						lead.calendarResource ? (
							<div className="flex flex-col sm:flex-row gap-x-4">
								<FormattedDate
									value={new Date(lead.calendarResource?.data?.dateFrom)}
									{...dateTimeFmtOpts}
								/>
								{lead.calendarResource?.data?.team?.data?.title}
							</div>
						) : (
							'-'
						)
					}
				/>
			</div>
		</Panel>
	);
}
